export const UPDATE_REGISTER_INFO = 'updateRegisterInfo';
export const UPDATE_PROCESS_REGISTER = 'updateProcessRegister';
